import { render, staticRenderFns } from "./assignLiaModal.vue?vue&type=template&id=10b09704&scoped=true"
import script from "./assignLiaModal.vue?vue&type=script&lang=js"
export * from "./assignLiaModal.vue?vue&type=script&lang=js"
import style0 from "./assignLiaModal.vue?vue&type=style&index=0&id=10b09704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b09704",
  null
  
)

export default component.exports